/**
 * Experiment to improve the speed when loading the category page
 */
export const CATNAV_TOP_OF_PAGE_SPEED_EXPERIMENT_240523 = 'CATNAV_TOP_OF_PAGE_SPEED_EXPERIMENT_240523';
